import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { InformationCircleIcon } from '@heroicons/react/24/outline'
import trackEvents from '../../constants/track-events'
import { useAivyContext, useLanguageContext } from '../../context'
import { classNames, isEmptyObj } from '../../helpers'
import { trackEvent } from '../../helpers/analytics'
import SlideOverDimensionDescription from '../team-analyse/SlideOverDimensionDescription'

const CulturalFitQuestions = ({ state, setState }) => {
  const { t } = useTranslation()

  const [hover, setHover] = useState({})
  const [openDimensions, setOpenDimensions] = useState(false)

  const {
    system: { dimensions_pdf_reports }
  } = useAivyContext()

  const culturalFitDimensions = {
    HEROS_JOURNEY_score_coopcomp: {
      key: 'HEROS_JOURNEY_score_coopcomp',
      ...dimensions_pdf_reports.HEROS_JOURNEY_score_coopcomp,
      leftImg: require('../../assets/images/teamwork.png'),
      rightImg: require('../../assets/images/independence.png'),
      leftImgAlt: require('../../assets/images/teamwork-alt.png'),
      rightImgAlt: require('../../assets/images/independence-alt.png'),
      leftImgBlue: require('../../assets/images/teamwork-blue.png'),
      rightImgBlue: require('../../assets/images/independence-blue.png')
    },
    HEROS_JOURNEY_score_orderchaos: {
      key: 'HEROS_JOURNEY_score_orderchaos',
      ...dimensions_pdf_reports.HEROS_JOURNEY_score_orderchaos,
      leftImg: require('../../assets/images/stability.png'),
      rightImg: require('../../assets/images/flexibility.png'),
      leftImgAlt: require('../../assets/images/stability-alt.png'),
      rightImgAlt: require('../../assets/images/flexibility-alt.png'),
      leftImgBlue: require('../../assets/images/stability-blue.png'),
      rightImgBlue: require('../../assets/images/flexibility-blue.png')
    }
  }

  const { language } = useLanguageContext()

  return (
    <>
      <div className='flex flex-col space-y-6'>
        {Object.values(culturalFitDimensions).map(
          (
            {
              key,
              property,
              intro,
              scaleEndpoints: { left, right },
              // leftImg,
              // rightImg,
              // leftImgAlt,
              // rightImgAlt,
              rightImgBlue,
              leftImgBlue
            },
            index
          ) => {
            const displayLeftOnHover = !isEmptyObj(hover) && hover[key] === 0
            const displayRightOnHover = !isEmptyObj(hover) && hover[key] === 100

            const displayLeft =
              !displayLeftOnHover && !displayRightOnHover && state[key] === 0
            const displayRight =
              !displayLeftOnHover && !displayRightOnHover && state[key] === 100

            return (
              <div
                key={index}
                className='relative flex flex-row justify-between rounded-lg bg-gray-50 p-6'
              >
                <div>
                  <h2
                    className='group flex cursor-pointer items-center text-lg font-semibold text-gray-900'
                    onClick={() => {
                      trackEvent(trackEvents.CLICK_MORE_INFO_DIMENSION, {
                        property: key
                      })
                      setOpenDimensions(culturalFitDimensions[key])
                    }}
                  >
                    {property[language]}
                    <InformationCircleIcon className='ml-1.5 h-6 w-6 text-gray-600 group-hover:text-gray-900' />
                  </h2>

                  <p className='mt-2 max-w-xl text-sm text-gray-900'>
                    {intro[language]}
                  </p>
                  <h3
                    style={{ fontSize: 16 }}
                    className='mt-4 font-semibold text-gray-900'
                  >
                    {t('cultural_fit.dimension_question')}
                  </h3>
                  <div className='mt-2' />
                  <span className='isolate inline-flex rounded-md shadow-sm'>
                    <button
                      type='button'
                      onClick={() => setState({ [key]: 0 })}
                      onMouseOver={() => setHover({ [key]: 0 })}
                      onMouseOut={() => setHover({})}
                      className={classNames(
                        'relative inline-flex items-center rounded-l-md px-5 py-2 text-sm font-semibold ring-1 ring-inset',
                        state[key] === 0
                          ? 'bg-blue-600 text-white ring-blue-600'
                          : 'bg-white text-gray-900 ring-gray-300 hover:bg-gray-50'
                      )}
                    >
                      {/* <img
                        src={state[key] === 0 ? leftImg : leftImgAlt}
                        className='md:block mr-2 h-8 w-auto'
                      /> */}
                      {left.title[language]}
                    </button>
                    <button
                      onMouseOver={() => setHover({ [key]: 100 })}
                      onMouseOut={() => setHover({})}
                      type='button'
                      onClick={() => setState({ [key]: 100 })}
                      className={classNames(
                        '-ml-px',
                        'relative inline-flex items-center rounded-r-md px-5 py-2 text-sm font-semibold ring-1 ring-inset',
                        state[key] === 100
                          ? 'bg-blue-600 text-white ring-blue-600'
                          : 'bg-white text-gray-900 ring-gray-300 hover:bg-gray-50'
                      )}
                    >
                      {/* <img
                        src={state[key] === 100 ? rightImg : rightImgAlt}
                        className='md:block mr-2 h-8 w-auto'
                      /> */}
                      {right.title[language]}
                    </button>
                  </span>
                  {(displayLeftOnHover || displayLeft) && (
                    <span className='mt-3 block max-w-md text-sm text-gray-900'>
                      {t('cultural_fit.dimension_selection', {
                        selection: left.description[language]
                      })}
                    </span>
                  )}
                  {(displayRightOnHover || displayRight) && (
                    <span className='mt-3 block max-w-md text-sm text-gray-900'>
                      {t('cultural_fit.dimension_selection', {
                        selection: right.description[language]
                      })}
                    </span>
                  )}
                </div>
                {state[key] === 0 && (
                  <img
                    src={leftImgBlue}
                    className='mr-4 hidden h-auto w-28 object-contain xl:block'
                  />
                )}
                {state[key] === 100 && (
                  <img
                    src={rightImgBlue}
                    className='mr-4 hidden h-auto w-28 object-contain xl:block'
                  />
                )}
              </div>
            )
          }
        )}
      </div>
      <SlideOverDimensionDescription
        open={openDimensions}
        setOpen={setOpenDimensions}
      />
    </>
  )
}

CulturalFitQuestions.propTypes = {
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired
}

export default CulturalFitQuestions
